module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 >> Deze pagina bestaat niet (meer)")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d8a476"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 631
// module chunks = 1